export const checkTypes = (actionType, constants) =>
  constants.map(i => Object.values(i)[0].type).includes(actionType);

export const translateResponse = response => {
  if (!response || !response.data) {
    return response;
  }
  return response.data;
};

export const capitalizeFirstLetter = string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const detectUrl = (pht) => {
  const sp = pht.split('https://');
  if (sp && sp.length === 2) {
    return { uri: pht };
  }
  return {uri: `data:image/jpeg;base64,${pht}`};
};

const deg2rad = deg => deg * (Math.PI / 180);
export const distanceEntre2Points = (lat1, lon1, lat2, lon2) => {
  const R = 6373;
  const radlat1 = deg2rad(lat1);
  const radlat2 = deg2rad(lat2);
  const theta = lon1 - lon2;
  const radtheta = deg2rad(theta);
  let dist = (Math.sin(radlat1) * Math.sin(radlat2)) + (Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta));
  dist = Math.acos(dist) * R;
  return dist.toFixed(2);
};
